<div class="modal-header">
	<h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.citations}}</h3>
</div>
<div class="modal-body">
	<div class="row">
		<div class="col-xs-6">		  
			<select class="form-control" [(ngModel)]="citationForm.style" (change)="generateCitations()">
			  <option *ngFor="let style of styles" [ngValue]="style">{{ style }}</option>
			</select>
		</div>
		<div class="col-xs-6">
			<button class="btn btn-default" type="button" (click)="copyToClipboard()">{{LOCALIZATION.clipboardCopy}}</button>
			<button class="btn btn-default" type="button" (click)="print()" [disabled]="!ready">{{LOCALIZATION.print}}</button>
		</div>
	</div>
	<br>
	<div #citationHolder id="citation-holder" style="overflow-y: auto; max-height: 500px;">
		<div class="panel panel-default background-default" *ngFor="let citation of citations">
			<div class="panel-body" appCitation [citation]="citation"></div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<div style="font-size: 12px; padding: 0 0 8px 0;"><em>{{LOCALIZATION.citationDisclaimer}}</em></div>
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.close}}</button>
</div>